module.exports = __webpack_public_path__ + "img/job-line.9e6a6640.svg";